(function($){
/*
	$(document.body).click(function() {
		$("body").removeClass("overlay");
		$(".c-lang").removeClass("open");
	});

*/
	$("#c-lang-in").click(function(e){
		if($(".c-lang").hasClass('open')){
			$("body").removeClass("overlay");
			$(".c-lang").removeClass("open");
		}else {
			$("body").addClass("overlay");
			$(".c-lang").addClass("open");
		}
		e.stopPropagation();
	});

	$("#c-lang__close").click(function(e){
		$("body").removeClass("overlay");
		$(".c-lang").removeClass("open");
		e.stopPropagation();
	});

	$(document.body).keyup(function(e) {
		if (e.key === 'Escape') {
			$("body").removeClass("overlay");
			$(".c-lang").removeClass("open");
		}
	});

	$(".c-lang__choice-lang-item-activ").click(function(e){

		if($(".c-lang__choice-lang-item-noactiv").hasClass('open')){
			$('.c-lang__choice-lang-item-noactiv').removeClass("open");
		}else {
			$('.c-lang__choice-lang-item-noactiv').addClass("open");
		}
		e.stopPropagation();
	});



})(jQuery);
